const i18n = require('i18n');
const KEY_1 = 'xWay';
const KEY_2 = 'xWays';

cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label,

        topContainer: cc.Node,
    },

    onLoad () {
        this.originParent = this.label.node.parent;
        this.originColor = this.label.node.color.clone();
        this.originScale = this.label.node.scaleX;
        this.isTotal = true;
        this.label.node.active = false;
        // this.updateTotalValue(1024);
    },

    hideWays () {
        this.label.string = '';
        this.label.node.active = false;
    },

    updateTotalValue(value) {
        this.total = value;
        this.setTotal();
    },

    setTotal() {


        if (!this.isTotal) {
            this.isTotal = true;

            this._clearTween();

            this.activeTween = cc.tween(this.label.node).
                to(0.1, { scale: 0 }).
                call(this._switch, this).
                to(0.1, { scale: this.originScale }).
                call(this._onWinHidden, this).
                start();
        } else {
            this._setText(this.total);
        }
        this.hideWays();
    },

    _switch() {
        if (this.isTotal) {
            this._setText(this.total);
            // this.label.node.color = this.originColor;
            this.label.node.setParentKeepPosition(this.originParent);
        } else {
            this._setText(this.winLine);
            // this.label.node.color = cc.Color.WHITE.clone();
            this.label.node.setParentKeepPosition(this.topContainer);
        }
    },

    showWinWays(count) {
        if (!count) {
            return;
        }
        this.label.node.active = true;
        this.winLine = count;
        if (this.isTotal) {
            this.isTotal = false;

            this.label.node.scale = this.originScale;

            this._clearTween();

            this.activeTween = cc.tween(this.label.node).
                to(0.1, { scale: 0 }).
                call(this._switch, this).
                to(0.1, { scale: this.originScale * 1.4 }).
                call(this._onWinShown, this).
                start();
        }
    },

    _onWinShown () {
        this.activeTween = null;
    },

    _onWinHidden () {
        this.activeTween = null;
    },

    _clearTween() {
        if(this.activeTween) {
            this.activeTween.stop();
            this.activeTween = null;
        }
    },

    _setText (count) {
        if (!count) {
            return;
        }
        if (count === 1) {
            this.label.string = count + ' Way';
        } else {
            this.label.string = count + ' Ways';
        }
    }
});
